var _defs, _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPas7Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1122 1122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke: #323a89;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 5.58px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: #323a89;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.82,151.47v148.69c0,87.67,39.39,169.44,108.09,224.34,26.91,21.5,42.34,52.3,42.34,84.51v13.74c0,32.21-15.43,63-42.34,84.51-68.69,54.9-108.09,136.67-108.09,224.34v133.21h575.14v-133.21c0-87.68-39.4-169.44-108.09-224.34-26.91-21.5-42.33-52.31-42.33-84.51v-13.74c0-32.19,15.42-63,42.33-84.51,68.69-54.9,108.09-136.66,108.09-224.34v-148.69H12.82Zm535.32,148.69c0,75.51-33.94,145.94-93.14,193.24-36.41,29.11-57.29,71.25-57.29,115.61v13.74c0,44.37,20.88,86.5,57.29,115.61,59.19,47.29,93.14,117.73,93.14,193.24v93.4H52.64v-93.4c0-75.5,33.94-145.94,93.13-193.24,36.41-29.1,57.29-71.23,57.29-115.61v-13.74c0-44.38-20.88-86.51-57.29-115.61-59.19-47.29-93.13-117.74-93.13-193.24v-108.8h495.51v108.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m181.83,450.08c47.65,39.42,77.64,96.22,77.64,158.2v24.95c0,61.98-30,118.79-77.64,158.2-41.01,34.11-67.29,85.47-67.29,142.94v35.79h371.62v-35.79c0-57.47-26.15-108.83-67.29-142.94-47.65-39.42-77.51-96.22-77.51-158.2v-24.95c0-61.98,29.86-118.79,77.51-158.2,20.84-17.25,37.82-39.02,49.64-63.84H132.32c11.68,24.82,28.67,46.58,49.5,63.84Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 990.43,
    y: 524.44,
    width: 77.74,
    height: 167.39,
    rx: 38.66,
    ry: 38.66,
    transform: "translate(1637.44 -421.17) rotate(90)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 618.65,
    y: 524.44,
    width: 77.74,
    height: 167.39,
    rx: 38.66,
    ry: 38.66,
    transform: "translate(1265.66 -49.38) rotate(90)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m843.41,710.33h0c21.38,0,38.87,17.49,38.87,38.87v89.65c0,21.38-17.49,38.87-38.87,38.87h0c-21.38,0-38.87-17.49-38.87-38.87v-89.65c0-21.38,17.49-38.87,38.87-38.87Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m843.41,338.55h0c21.38,0,38.87,17.49,38.87,38.87v89.65c0,21.38-17.49,38.87-38.87,38.87h0c-21.38,0-38.87-17.49-38.87-38.87v-89.65c0-21.38,17.49-38.87,38.87-38.87Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m915.68,680.4h0c15.12-15.12,39.85-15.12,54.97,0l63.39,63.39c15.12,15.12,15.12,39.85,0,54.97h0c-15.12,15.12-39.85,15.12-54.97,0l-63.39-63.39c-15.12-15.12-15.12-39.85,0-54.97Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m652.78,417.51h0c15.12-15.12,39.85-15.12,54.97,0l63.39,63.39c15.12,15.12,15.12,39.85,0,54.97h0c-15.12,15.12-39.85,15.12-54.97,0l-63.39-63.39c-15.12-15.12-15.12-39.85,0-54.97Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m771.15,680.4h0c15.12,15.12,15.12,39.85,0,54.97l-63.39,63.39c-15.12,15.12-39.85,15.12-54.97,0h0c-15.12-15.12-15.12-39.85,0-54.97l63.39-63.39c15.12-15.12,39.85-15.12,54.97,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1034.04,417.51h0c15.12,15.12,15.12,39.85,0,54.97l-63.39,63.39c-15.12,15.12-39.85,15.12-54.97,0h0c-15.12-15.12-15.12-39.85,0-54.97l63.39-63.39c15.12-15.12,39.85-15.12,54.97,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPas7Icon);
export default __webpack_public_path__ + "static/media/pas7Icon.670905ea087972cbc135149a55d2d620.svg";
export { ForwardRef as ReactComponent };